import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { SwatchComponentDef } from '@df/catalog-ui/product/swatch/swatch.component.def';
import { Catalog } from '@df/catalog/catalog.interfaces';
import { ImageModule } from '@df/module-image/image.module';
import { BgContrastDirective } from '@df/ui/atomic/atom/color/bg-contrast.directive';
/**
 * You can pass either option or value + attributeCode pair
 *
 * <swatch [option]="option"></swatch>
 * <swatch [value]="colorValue" attributeCode="color"></swatch>
 */
@Component({
    selector: 'swatch',
    templateUrl: './swatch.html',
    styleUrls: ['./swatch.scss'],
    standalone: true,
    imports: [NgClass, BgContrastDirective, ImageModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SwatchComponent extends SwatchComponentDef {
    @Input()
    optionBig = false;
    @Input()
    optionHuge = false;
    @Input()
    optionSmall = false;
    @Input()
    @HostBinding('class.is-disabled')
    disabled = false;
    @Input({
        required: true
    })
    override option!: Catalog.IAttributeOption;
}
